import { $Q } from '../utils/query-selector';

const swiperHero = async () => {
  const { Swiper, Pagination, Autoplay } = await import('swiper');

  return new Swiper('.hero_slider', {
    modules: [Pagination, Autoplay],
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      disableOnInteraction: false,
    },
  });
};

/**
 * Get dataset autoplay in slider hero and set swiper
 * @returns null - stop called
 * @author Daniel Santos
 */
export async function stopAutplaySlider(observer) {
  let heroComponent = $Q('.hero--slider .swiper');

  if (!heroComponent) {
    observer.disconnect();

    return;
  }
  const heroSlider = await swiperHero();

  heroComponent = heroComponent.dataset.autoplay;

  if (heroComponent === 'false') heroSlider.autoplay.stop();
}
